import React from 'react';
import styles from './styles.module.css';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

const Menu = ({
    active,
    white,
    history: {
        location: {
            pathname = '/',
        } = {}
    } = {},
    menus = []
}) => {
    return (
        <div className={styles.main}>
            {
                menus.map(
                    ({ path, title }, index) => (
                        <div
                            key={`menu-${index}`}
                            className={`${styles.menuItem} ${pathname.indexOf(path) == 0 ? styles.active : ''} ${white ? styles.white : ''}`}>
                            <Link to={`${path}`}>{title}</Link>
                            <div className={styles.underbar} />
                        </div>)
                )
            }
        </div>
    );
};

export default withRouter(Menu);